import { render, staticRenderFns } from "./Bing1.vue?vue&type=template&id=a1182ee4&scoped=true"
import script from "./Bing1.vue?vue&type=script&lang=js"
export * from "./Bing1.vue?vue&type=script&lang=js"
import style0 from "./Bing1.vue?vue&type=style&index=0&id=a1182ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1182ee4",
  null
  
)

export default component.exports